var _linearGradient, _circle, _linearGradient2, _path, _linearGradient3, _circle2, _linearGradient4, _path2, _linearGradient5, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _linearGradient6, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ConferenceForegroundSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0a",
    x1: 8.608,
    x2: 15.584,
    y1: -1115.498,
    y2: -1122.474,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 5,
    fill: "url(#m~~38RfyeFSoVmxmtoYj0a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0b",
    x1: 4.431,
    x2: 19.998,
    y1: -1130.372,
    y2: -1145.938,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m~~38RfyeFSoVmxmtoYj0b)",
    d: "M12,22c-4.971,0-9,4.029-9,9v9c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2v-9 C21,26.029,16.971,22,12,22z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0c",
    x1: 32.608,
    x2: 39.584,
    y1: -1115.498,
    y2: -1122.474,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 15,
    r: 5,
    fill: "url(#m~~38RfyeFSoVmxmtoYj0c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0d",
    x1: 28.431,
    x2: 43.998,
    y1: -1130.372,
    y2: -1145.938,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m~~38RfyeFSoVmxmtoYj0d)",
    d: "M36,22c-4.971,0-9,4.029-9,9v9c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2v-9 C45,26.029,40.971,22,36,22z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0e",
    x1: 20.608,
    x2: 27.584,
    y1: -1111.498,
    y2: -1118.474,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 11,
    r: 5,
    fill: "url(#m~~38RfyeFSoVmxmtoYj0e)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35,40V27c0-1.701-0.399-3.307-1.092-4.746 C29.948,23.199,27,26.751,27,31v9c0,1.105,0.895,2,2,2h5.444C34.788,41.409,35,40.732,35,40z",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.333,40V27c0-1.621-0.385-3.15-1.053-4.517 C29.649,23.602,27,26.987,27,31v9c0,1.105,0.895,2,2,2h4.296C33.894,41.606,34.333,40.856,34.333,40z",
    opacity: 0.067
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.667,40V27c0-1.542-0.371-2.994-1.014-4.288 C29.35,24.005,27,27.223,27,31v9c0,1.105,0.895,2,2,2h3.148C32.999,41.803,33.667,40.98,33.667,40z",
    opacity: 0.09
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13,40V27c0-1.701,0.399-3.307,1.092-4.746 C18.052,23.199,21,26.751,21,31v9c0,1.105-0.895,2-2,2h-5.444C13.212,41.409,13,40.732,13,40z",
    opacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.667,40V27c0-1.621,0.385-3.15,1.053-4.517 C18.351,23.602,21,26.987,21,31v9c0,1.105-0.895,2-2,2h-4.296C14.106,41.606,13.667,40.856,13.667,40z",
    opacity: 0.067
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.333,40V27c0-1.542,0.371-2.994,1.014-4.288 C18.65,24.005,21,27.223,21,31v9c0,1.105-0.895,2-2,2h-3.148C15.001,41.803,14.333,40.98,14.333,40z",
    opacity: 0.09
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m~~38RfyeFSoVmxmtoYj0f",
    x1: 21.181,
    x2: 26.202,
    y1: -1122.947,
    y2: -1148.05,
    gradientTransform: "matrix(1 0 0 -1 0 -1103.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m~~38RfyeFSoVmxmtoYj0f)",
    d: "M24,18c-4.971,0-9,4.029-9,9v13c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V27 C33,22.029,28.971,18,24,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ConferenceForegroundSelected);
export default __webpack_public_path__ + "static/media/icons8-conference-foreground-selected.143e20c51e1d598895901f600c786965.svg";
export { ForwardRef as ReactComponent };